import React from "react";
import zinc_logo from "../assets/images/others/zincLogo.png";
import { Nav, Navbar, Container } from "react-bootstrap";
const navigation = (props) => {
  return (
    <>
      <Navbar collapseOnSelect className="ttt" fixed="top" bg="transparent" variant="dark" expand="lg" > 
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <img src={zinc_logo} alt="" width="50" className="navImage m-auto d-lg-none"/>
          <Navbar.Collapse bg="dark" className="text-center" id="basic-navbar-nav">
            
            <Nav className="m-auto bottomstyling container d-flex justify-content-evenly align-items-center">
              <Nav.Link className="" href="#home">
                <img width="135" height="30" src={`${process.env.REACT_APP_IMAGE_STORAGE}${props.icon_image_path}`} alt="" />
              </Nav.Link>
                  <Nav.Link className="" href="#about">about</Nav.Link>
                  <Nav.Link className="" href="#service">service</Nav.Link>
              <Navbar.Brand href="#home" className="d-none d-lg-block">
                <img
                  src={zinc_logo}
                  width="50"
                  className="d-inline-block align-top d-none d-lg-block"
                  alt=""
                />
              </Navbar.Brand>
              <Nav.Link className="" href="#menu">menu</Nav.Link>
              <Nav.Link className="" href="#gallery">gallery</Nav.Link>
              {/* ??? */}
              <Nav.Link className="d-none d-lg-block" href="#contact">contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default navigation;